import React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import { IS_PROD } from '../../api/client';
import { firebaseConfig } from '../../Common/QmoConfiguration';

class Firebase {
    auth: firebase.auth.Auth
    provider: firebase.auth.GoogleAuthProvider
    constructor() {
        firebase.initializeApp(firebaseConfig)
        this.auth = firebase.auth()
        this.provider = new firebase.auth.GoogleAuthProvider()
    }

    signOut() {
        return this.auth.signOut()
    }
}

export default Firebase

export const FirebaseContext = React.createContext({})
